import { TAwtgRanDetailsDTO } from '@interfaces/cmModule/dto/historyCheckDTO';

import { useQueryHistoryCheckAwtgRanDetails } from './useQueryHistoryCheckAwtgRanDetails';
import { useQueryHistoryCheckAwtgRanMoIds } from './useQueryHistoryCheckAwtgRanMoIds';
import { useQueryHistoryCheckAwtgRanMoNames } from './useQueryHistoryCheckAwtgRanMoNames';
import { useQueryHistoryCheckAwtgRanNeNames } from './useQueryHistoryCheckAwtgRanNeNames';

type TUseHistoryDetailsAwtgRanParams = TAwtgRanDetailsDTO & {
	isAwtgRanVendor?: boolean;
};

export const useHistoryDetailsAwtgRan = (params: TUseHistoryDetailsAwtgRanParams) => {
	const {
		dumpHistoryId,
		dataModelPathId,
		isAwtgRanVendor,
	} = params;

	const { historyDetails, isLoadingDetails } = useQueryHistoryCheckAwtgRanDetails({
		...params,
		isAwtgRanVendor,
	});

	const { moIdsOptions } = useQueryHistoryCheckAwtgRanMoIds({
		dumpHistoryId,
		dataModelPathId,
		moName: '',
		isAwtgRanVendor,
	});

	const { moNamesOptions } = useQueryHistoryCheckAwtgRanMoNames({
		dumpHistoryId,
		dataModelPathId,
		isAwtgRanVendor,
	});

	const { neNamesOptions } = useQueryHistoryCheckAwtgRanNeNames({
		dumpHistoryId,
		dataModelPathId,
		isAwtgRanVendor,
	});

	return {
		dataModelPath: historyDetails?.dataModelPath || null,
		moIdsOptions,
		moNamesOptions,
		neNamesOptions,
		dumpHistoryId: historyDetails?.dumpHistoryId || null,
		dataModelPathId: historyDetails?.dataModelPathId || null,
		historyDetails: historyDetails?.rows?.items || [],
		historyDetailsTotal: historyDetails?.rows?.count || 0,
		isLoadingDetails,
	};
};
